module.exports = __webpack_public_path__ + "static/media/eazegames.59a4d35d.png";